__turbopack_context__.v({
  "aboutbox1": "might-be-interest-module__9rz5QW__aboutbox1",
  "img": "might-be-interest-module__9rz5QW__img",
  "sectionsubtitle": "might-be-interest-module__9rz5QW__sectionsubtitle",
  "sectiontitle": "might-be-interest-module__9rz5QW__sectiontitle",
  "star": "might-be-interest-module__9rz5QW__star",
});
